module.exports = __webpack_public_path__ + "static/img/icon.198e4fbf.png";